import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { FeedProvider } from '../contexts/FeedContext';
import Feed from '../components/feed/Feed';
import CreatePost from '../components/feed/CreatePost';

const HomePage = () => {

  return (
    <FeedProvider>
      <Container maxWidth="md" sx={{ py: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 3, fontWeight: 'bold' }}>
          Home
        </Typography>
        
        <Box sx={{ mb: 3 }}>
          <CreatePost />
        </Box>
        
        <Feed />
        
        <Box mt={4} textAlign="center">
          <Typography variant="body2" color="text.secondary">
            Social Project Management v0.2.0
          </Typography>
        </Box>
      </Container>
    </FeedProvider>
  );
};

export default HomePage;
